import { Component, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import * as uuid from 'uuid';

@Component({
    selector: 'app-bciti-time-input',
    templateUrl: './bciti-time-input.component.html',
    styleUrls: ['./bciti-time-input.component.scss'],
})
export class BcitiTimeInputComponent implements ControlValueAccessor {
    @Input() step: number = 900000;

    public onChange: (param?: any) => any;
    public onTouched: () => any;
    public id: string = uuid.v4();
    public _value: any = '';

    // YYYY/MM/DD
    public mask = {
        guide: false,
        showMask: false,
        mask: [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/],
    };

    @Input() disabled: boolean;
    @Input() label: string = null;
    @Input() placeholder: string = this.label;
    @Input() type: 'text' | 'email' | 'password' | 'number' = 'text';
    @Input() validation = true;
    @Input() max: Date;
    @Input() min: Date;
    @Input() disableMessages: boolean = false;
    @Output('change') changeOutput = new EventEmitter<any>();
    @ViewChild('input', { static: true }) input;

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(v) {
        this.value = v;
    }

    get invalid() {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid() {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine() {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty() {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched() {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    writeValue(value: any): void {
        this._value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }
}
